import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import List from './List';
import View from './View';
import { useSnackbar } from 'notistack';
import { MenuItem } from '@mui/material';
import {
  FilterBox,
  PageHeader,
  PageAction,
  PrimaryButton,
  FormButton,
  SelectFilterField,
  SecondaryPage,
} from '@/Theme';
import { AdminSvc } from '@/Services';

const Home = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [listData, setListData] = useState([]);
  const [filter, setFilter] = useState({ search: "", status: ["New", "Failed"] });
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState(['New', 'Failed']);
  const [type, setType] = useState([]);
  const [count, setCount] = useState(0);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(1);
  const [sort, setSort] = useState('created');
  const [direction, setDirection] = useState('desc');
  //For editing
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const { enqueueSnackbar } = useSnackbar();

  const filters = {
    where: {},
    size: size,
    page: page,
    sort: sort,
    order: direction,
  };
  const fetch = async () => {
    setLoading(true);
    filters.where = filter;
    let response = await AdminSvc.searchWixLogs(filters);
    if (response && response.data && response.data.objects) {
      const objects = response.data.objects;
      setListData(objects);
      setCount(response.data.count);
    }
    setLoading(false);
  };
  useEffect(() => {
    console.log('### fetch test types', search, size, page, sort, direction);
    fetch();
  }, [filter, size, page, sort, direction]);

  const onSearchChange = (e) => {
    e.preventDefault();
    setSearch(e.target.value);
  };
  const onSearchPressed = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      let updatedFilter = { ...filter, ...{ search: e.target.value } }
      setFilter(updatedFilter);
    }
  };
  const handleView = (log) => {
    setSelectedItem(log);
    setOpenDrawer(true);
  };
  const contentDrawer = () => {
    let drawerContent = '';
    if (openDrawer) {
      drawerContent = (
        <View
          openDrawer={openDrawer}
          setOpenDrawer={setOpenDrawer}
          log={selectedItem}
        />
      );
    }
    return drawerContent;
  };
  const handlePullOrders = async () => {
    let response = await AdminSvc.pullWixOrders();
    if (response) {
      console.log("###### pull wix order complete", response.data);
      enqueueSnackbar('Pull orders completed.', { variant: 'success' });
      fetch();
    }
  }
  return (
    <SecondaryPage title='Wix Logs' back='/admin/dashboard' actions={
      <>
        <PrimaryButton  primary="true" compact="true" size='small' onClick={handlePullOrders}>
          Pull Orders
        </PrimaryButton>
      </>
    }>
      <PageHeader>
        <PageAction>
          <FilterBox
            onChange={onSearchChange} onPress={onSearchPressed}
          />
        </PageAction>
      </PageHeader>
      <List
        listData={listData}
        setOpenDrawer={setOpenDrawer}
        loading={loading}
        handleView={handleView}
        count={count}
        size={size}
        setSize={setSize}
        page={page}
        setPage={setPage}
        sort={sort}
        setSort={setSort}
        direction={direction}
        setDirection={setDirection}
        refreshData={fetch}
      />
      {contentDrawer()}
    </SecondaryPage>
  );
};
export default Home;
